import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import 'AWS-UI-Components-React/index.css'
import './styles/index.css'

import App from './components/App'
import { store } from './common/Store.js'

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js